import { render, staticRenderFns } from "./Committees.vue?vue&type=template&id=760c85a6"
import script from "./Committees.vue?vue&type=script&lang=js"
export * from "./Committees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports